export const Strong = {
  easeOut: 'cubic-bezier(0.1, 0.9, 0.2, 1)',
};

export const Circ = {
  easeOut: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
  easeIn: 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
  easeInOut: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
};

export const Back = {
  easeOut: 'cubic-bezier(1,.01,.1,1.32)',
};
